export const appBaseURL = "/ifen/catalog"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/png","href":"/ifen/catalog/favicon.png"}],"style":[],"script":[{"src":"https://tarteaucitron.io/load.js?domain=ssl.education.lu%2Fifen&uuid=c83c1612c7faeb588bc7d60c5b9fbfe1991c8a70","async":true,"defer":true,"onload":"initTarteAuCitron()"},{"type":"text/javascript","innerHTML":"\n\t\t\t\t\twindow.initTarteAuCitron = function() {\n\t\t\t\t\t\tif (typeof tarteaucitron === 'undefined') {\n\t\t\t\t\t\t\tsetTimeout(initTarteAuCitron, 300);\n\t\t\t\t\t\t\treturn;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t/* Google Analytics */\n\t\t\t\t\t\ttarteaucitron.user.gtagUa = 'G-SYKMLW6VKP';\n\t\t\t\t\t\t(tarteaucitron.job = tarteaucitron.job || []).push('gtag');\n\n\t\t\t\t\t\t/* Google Tag Manager */\n\t\t\t\t\t\ttarteaucitron.user.googletagmanagerId = 'GTM-TFZ8CLHX';\n\t\t\t\t\t\t(tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');\n\n\t\t\t\t\t\t/* Microsoft Clarity */\n\t\t\t\t\t\ttarteaucitron.user.clarityId = 'q5h9my21ni';\n\t\t\t\t\t\t(tarteaucitron.job = tarteaucitron.job || []).push('clarity');\n\t\t\t\t\t};\n\t\t\t\t","tagPosition":"bodyClose"}],"noscript":[]}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true